import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';

import Favorite from '@pedidosya/web-fenix/icons/Favorite';
import { onKeyUpFunction, onKeyDownFunction } from '@utils/a11y';

const heartEffect = keyframes`
  0% { transform: scale(1); } 
  50% { transform: scale(1.2); } 
  100% { transform: scale(1); }
`;

const AnimatedHeart = styled.div`
  display: flex;
  ${props =>
    props.active &&
    css`
      animation: ${heartEffect} 0.5s;
    `};
`;

function Heart({ isFavorite, onClick, color, className }) {
  const clickHandler = useCallback(
    event => {
      onClick();
      event.stopPropagation();
      event.preventDefault();
    },
    [onClick],
  );
  return (
    <AnimatedHeart
      active={isFavorite}
      onClick={clickHandler}
      onKeyUp={e => onKeyUpFunction(e, () => clickHandler(e))}
      onKeyDown={e => onKeyDownFunction(e, () => clickHandler(e))}
      className={className}
      aria-pressed={isFavorite}
      role="button"
      tabIndex={0}
      aria-label="Favorito"
    >
      <Favorite size="small" filled={isFavorite} color={color} />
    </AnimatedHeart>
  );
}

Heart.propTypes = {
  onClick: PropTypes.func.isRequired,
  isFavorite: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  color: PropTypes.string,
};

export default styled(Heart)``;
